module.exports = __webpack_public_path__ + "static/3-a14602e7dd8a7dead0b9968d1012e2a1.jpeg";